import { render } from "./loading-script.vue?vue&type=template&id=3da52e9a&scoped=true"
import script from "./loading-script.vue?vue&type=script&lang=js"
export * from "./loading-script.vue?vue&type=script&lang=js"

import "./loading-script.vue?vue&type=style&index=0&id=3da52e9a&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da52e9a"]])

export default __exports__